'use strict';

var React = require('react'),
    StampStore = require('../stores/StampStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    DocumentTitle = require('../atoms/DocumentTitle'),
    StampDraftStore = require('../stores/StampDraftStore'),
    UserStore = require('../stores/UserStore'),
    GrabbagImageStore = require('../stores/GrabbagImageStore'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    parseStampSegment = require('../utils/parseStampSegment'),
    getStampSegment = require('../utils/getStampSegment'),
    shallowEqual = require('react/lib/shallowEqual'),
    { Navigation, RouteHandler } = require('react-router'),
    { throttle } = require('underscore');

const throttledSaveDraft = throttle(function () {
  if (StampDraftStore.isReady()) {
    DraftActionCreators.saveDraft();
  }
}, 2000);

var DraftPage = React.createClass({
  mixins: [PureRenderMixin, Navigation, createStoreMixin(StampStore, StampDraftStore, GrabbagImageStore)],

  statics: {
    willTransitionTo(transition, params) {
      const { stampSegment } = params;
      const currentDraft = StampDraftStore.getDraftStamp();
      const isCurrentDraft = currentDraft && shallowEqual(
        getStampSegment(currentDraft),
        stampSegment
      );

      if (isCurrentDraft) {
        return;
      }

      const { stampId, draftUuid, isNewDraft, isDraft, isStamp } = parseStampSegment(stampSegment);
      if (isNewDraft && UserStore.isAuthenticated()) {
        DraftActionCreators.loadEmptyDraft();

        if (StampDraftStore.hasUnsavedChanges()) {
          // This is a legacy draft migrated from localStorage. Save it!
          throttledSaveDraft();
        }
      } else if (isStamp) {
        DraftActionCreators.loadStampInEditor(stampId);
      } else if (isDraft) {
        DraftActionCreators.loadDraftInEditor(draftUuid);
      }
    }
  },

  getStateFromStores(props) {
    const { isDraft, isNewDraft } = parseStampSegment(props.params.stampSegment || '');

    return {
      grabbag: GrabbagImageStore.getUploadedImageItems(),
      draft: StampDraftStore.getDraftStamp(),
      isEmpty: StampDraftStore.isEmpty(),
      isDraft: isDraft,
      isNewDraft: isNewDraft
    };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  componentDidUpdate(prevProps, prevState) {
    const { isDraft, draft, grabbag, isEmpty } = this.state;
    const isDraftAndReady = isDraft && Boolean(draft) && Boolean(prevState.draft);
    const isChanged = draft !== prevState.draft || grabbag !== prevState.grabbag;

    if (isDraftAndReady && draft.canEdit && isChanged && (!isEmpty || draft.uuid)) {
      throttledSaveDraft();
    }
  },

  render() {
    const { stampSegment } = this.props.params;
    const { draft } = this.state;

    return (
      <DocumentTitle title={draft && draft.title}>
        <RouteHandler {...{ draft, stampSegment }} />
      </DocumentTitle>
    );
  }
});

module.exports = DraftPage;


/** WEBPACK FOOTER **
 ** ./pages/DraftPage.jsx
 **/